module.exports = __webpack_public_path__ + "static/media/brush.6f4d4fb2.svg";